import type { Targeting } from "@foundation/sparkle/lib/AdTargeting/TargetingProvider";
import type { SparkleProviderProps } from "@foundation/sparkle/lib/types";

const DEFAULT_BREAKPOINTS = {
    mobile: 0,
    tablet: 760,
    small_desktop: 1020,
    large_desktop: 1280,
};

type ValidOptionsValue =
    | string
    | null
    | number
    | object
    | boolean
    | undefined
    | Array<ValidOptionsValue>;

export const AD_DOUBLEVERIFY_SCRIPT_PERF_IMPROVEMENT =
    "https://pub.doubleverify.com/dvtag/24434720/DV1462763/pub.js";

export const getSparkleProviderOptions = (
    pageId: string,
    adCode: string,
    adBreakpoints?: Record<string, ValidOptionsValue>,
    targeting?: Targeting
): Omit<SparkleProviderProps, "children"> => {
    const breakpoints = adBreakpoints || DEFAULT_BREAKPOINTS;

    return {
        defaultAdCode: adCode,
        sparkleInitOptions: {
            useCachedConsent: true,
            pageTargeting: {
                page: pageId,
                ...targeting,
            },
            breakpoints,
            observerOptions: { rootMargin: "0px 0px 300px 0px" },
            disableIAS: true,
            enableBombora: true,
            disableTrigr: targeting?.tr !== undefined,
            isDecoupled: true,
            dvScriptUrl: AD_DOUBLEVERIFY_SCRIPT_PERF_IMPROVEMENT,
            adContextData: { adCode, adPageType: "other" },
            excludeTargetingTypes: ["content"],
        },
    } as Omit<SparkleProviderProps, "children">;
};

type AdType = "leaderboard";

export interface AdOptions {
    hideEmptyAd?: boolean;
    isDecoupled?: boolean;
}

const AD_HIDE_EMPTY_PAGE_IDS = new Set(["phx-industries-health"]);

function getAdOptions(adType: AdType, pageId: string): AdOptions {
    switch (adType) {
        case "leaderboard": {
            return {
                hideEmptyAd: AD_HIDE_EMPTY_PAGE_IDS.has(pageId),
                isDecoupled: true,
            };
        }

        default: {
            return {};
        }
    }
}

export function getLeaderboardAdOptions(pageId: string): AdOptions {
    return getAdOptions("leaderboard", pageId);
}
